import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { fetchApiData } from "../../../store/slicers/apiSlicer.js";

const VideoSection = () => {
  const dispatch = useDispatch();
  const [videos, setVideos] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);

  const { data, isLoading } = useSelector((state) => ({
    data: state.apiData?.data?.videos,
    isLoading: state.apiData?.loading?.videos,
  }));

  useEffect(() => {
    getVideos();
  }, []);

  useEffect(() => {
    if (data?.data) {
      setVideos(data.data);
    }
  }, [data]);

  const getVideos = (page = 1) => {
    dispatch(
      fetchApiData({
        url: "youtube_medias?page=" + page,
        itemKey: "videos",
      })
    );
    setCurrentPage(page);
  };

  if (isLoading) {
    return (
      <div className="videos-section">
        <h2 className="section-title">
          <i className="pi pi-video"></i> Vidéos ONPR
        </h2>
        <div className="videos-grid">
          {[1, 2, 3, 4].map((i) => (
            <div key={i} className="video-card-placeholder">
              <div className="placeholder-video"></div>
              <div className="placeholder-content">
                <div className="placeholder-line"></div>
                <div className="placeholder-line short"></div>
              </div>
            </div>
          ))}
        </div>
      </div>
    );
  }

  return (
    <div className="videos-section">
      <h2 className="section-title">
        <i className="pi pi-video"></i> Vidéos ONPR
      </h2>
      {videos.length === 0 ? (
        <div className="no-data-placeholder">
          <i
            className="pi pi-video"
            style={{ fontSize: "4rem", color: "#ccc" }}
          ></i>
          <p>Aucune vidéo disponible pour le moment</p>
        </div>
      ) : (
        <>
          <div className="videos-grid">
            {videos.map((video) => (
              <div key={video.id} className="video-card">
                <div className="video-wrapper">
                  <iframe
                    src={`https://www.youtube.com/embed/${video.youtube_media}?rel=0&modestbranding=1`}
                    title={video.youtube_title}
                    frameBorder="0"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                    allowFullScreen
                  />
                </div>
                <div className="video-info">
                  <h3 className="video-title">{video.youtube_title}</h3>
                  <div className="video-date">
                    {new Date(video.created_at).toLocaleDateString("fr-FR")}
                  </div>
                </div>
              </div>
            ))}
          </div>
          {data?.last_page > 1 && (
            <div className="pagination">
              <button
                onClick={() => getVideos(currentPage - 1)}
                disabled={currentPage === 1}
                className="pagination-btn"
              >
                <i className="pi pi-angle-left"></i> Précédent
              </button>
              <span className="pagination-info">
                Page {currentPage} sur {data.last_page}
              </span>
              <button
                onClick={() => getVideos(currentPage + 1)}
                disabled={currentPage === data.last_page}
                className="pagination-btn"
              >
                Suivant <i className="pi pi-angle-right"></i>
              </button>
            </div>
          )}
        </>
      )}
    </div>
  );
};

export default VideoSection;
